module.exports = __webpack_public_path__ + "static/p6.2bffe1ed.jpg";